// TEMP: 원격진단>리프로그램 및 S/W관리 메뉴를 특정 계정만 볼 수 있도록 임시 제한.
// 해제 시 이 파일과 router.js / Menu.vue 의 import 및 호출을 함께 제거할 것.

export const TEMP_RESTRICTED_MENU_WHITELIST = [
  'shh3231', 'mjha', 'mauus',
  '111636', 'daedong123', // DDAT-1113: SW Management 접근 화이트리스트 추가
];

// 직접 URL 접근을 차단할 라우트 name 목록 (router.js 라우트 정의 기준)
export const TEMP_RESTRICTED_ROUTE_NAMES = [
    'reProgram', 'reProgramDetail', 'reProgramHistory',
    'swModel', 'swModelDetail', 'swModelRegi', 'swModelModify', 'swVehicle',
];

// Menu.vue 메뉴 목록 필터링 기준 (서버가 내려주는 menu.key / children.key)
export const TEMP_RESTRICTED_PARENT_KEYS = ['swMng'];
export const TEMP_RESTRICTED_CHILD_KEYS_BY_PARENT = {
    // 서버 menu_key 는 소문자 'reprogram' — 카멜('reProgram')로 두면 대소문자 불일치로 숨김이 안 걸린다 (DDAT-1539)
    remoteService: ['reprogram'],
};

// 환경 무관 항상 제한 적용.
export function isTempRestrictedMenuAllowed(loginId) {
    return TEMP_RESTRICTED_MENU_WHITELIST.includes(loginId);
}
